import { useState } from "react";
import IconButton from "../components/IconButton";
import styles from "./FullScreenToggle.module.css";
import { TRootState } from "../store/create-store";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { selectRightPanelState } from "../selectors";

const FullScreenToggle = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { rightPanelVisible } = useSelector(selectFullScreenToggle);

  const onToggle = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => {
        setIsFullScreen(true);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          setIsFullScreen(false);
        });
      }
    }
  };

  return (
    <IconButton
      onClick={onToggle}
      name={isFullScreen ? "fullscreen_exit" : "fullscreen"}
      buttonClass={classNames(styles.icon, {
        [styles.withRightPanel]: rightPanelVisible,
      })}
    />
  );
};

const selectFullScreenToggle = (state: TRootState) => ({
  rightPanelVisible: selectRightPanelState(state).visible,
});

export default FullScreenToggle;
